import React, { useMemo } from 'react';

import linkOutIcon from 'images/directory/link_out_icon.svg';

import Pill from '@components/Pill';
import { subscriber_directories_path, topic_landing_path } from '@routes';
import { ProfileEntity } from '@utils/backend-api/subscriber_directory';

interface SectionProps {
  color: string;
  entities: ProfileEntity[];
  fieldName: string;
  param: string;
  pluralFieldName: string;
  profileName: string;
}

const Section = ({
  color,
  entities,
  fieldName,
  param,
  pluralFieldName,
  profileName,
}: SectionProps) => {
  const numberofCommonEntities = useMemo(() => entities?.filter((t) => t.match).length, [entities]);
  return (
    <div className="section-detail with-pills">
      {numberofCommonEntities > 0 && (
        <div className="common-intro">
          You and {profileName} have {numberofCommonEntities}{' '}
          {numberofCommonEntities > 1 ? pluralFieldName : fieldName} in common
        </div>
      )}
      {entities.map((entity, id) => (
        <Pill
          href={
            param === 'topic'
              ? topic_landing_path(entity.value.toLowerCase())
              : subscriber_directories_path({ [param]: entity.value.toLowerCase() })
          }
          className={`--${color} ${entity.match ? 'common-pill' : ''}`}
          text={entity.value}
          icon={linkOutIcon}
          key={id}
        />
      ))}
    </div>
  );
};

export default Section;
